exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".approval-dialog .el-dialog__body{overflow:unset}", ""]);

// exports
